import { ChartComponent } from "./Component";

export default ChartComponent;